function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "Group");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-3",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "onboarding-1",
  transform: "translate(-124.000000, -265.000000)",
  fill: "#919EAB"
}, React.createElement("g", {
  id: "Group",
  transform: "translate(179.902808, 320.420563) rotate(2.000000) translate(-179.902808, -320.420563) translate(123.902808, 264.920563)"
}, React.createElement("path", {
  d: "M86.9198446,54.500947 C86.9197368,54.4978049 86.9196285,54.4946627 86.9195197,54.4915204 C86.3256889,37.3371687 72.0589469,23.9164395 55.0538594,24.5154826 C38.0487719,25.1145258 24.7448197,39.5064959 25.3386504,56.6608476 C25.9324811,73.8151993 40.1992232,87.2359285 57.2043107,86.6368853 C57.2074529,86.6367747 57.210595,86.6366635 57.213737,86.6365519 L58.0491309,110.559103 C27.41636,111.628823 1.72395893,87.8793109 0.663546894,57.5130833 C-0.396865142,27.1468556 23.5762683,1.66298491 54.2090392,0.593264982 C84.8418101,-0.476454948 110.534211,23.273057 111.594623,53.6392847 L86.9198446,54.500947 Z",
  id: "Combined-Shape"
}), React.createElement("path", {
  d: "M58.3415252,56.364309 L79.3423947,56.364309 C83.2083879,56.364309 86.3423947,59.4983157 86.3423947,63.364309 L86.3423947,84.3651784 L65.3415252,84.3651784 C61.475532,84.3651784 58.3415252,81.2311717 58.3415252,77.3651784 L58.3415252,56.364309 Z",
  id: "Rectangle-Copy",
  transform: "translate(72.341960, 70.364744) rotate(88.000000) translate(-72.341960, -70.364744) "
}))));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "112px",
    height: "111px",
    viewBox: "0 0 112 111",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/coinbarter.b5606e1b.svg";
export { SvgComponent as ReactComponent };